import { useCan, useSelectedDealer } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { WebhooksQueryKeys } from "modules/WebhooksDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDealerChecklistsQuery = () => {
  const { selectedDealer } = useSelectedDealer();
  const canListDealers = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.Dealers);

  return useTypedQuery({
    queryKey: WebhooksQueryKeys.dealerChecklists,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { id: selectedDealer?.id || 0, embed: "checklist" }, baseUrl)).data,
    enabled: false,
    refetchOnDependencies: [selectedDealer?.id, canListDealers]
  });
};
